import Vue from 'vue' // 引入vue
import Vuex from 'vuex' // 引入vuex

// 使用vuex
Vue.use(Vuex)

// 创建vuex实例
const store = new Vuex.Store({
  state: {
    activeIndex: 'Home',
    activeIndexM: 'mHome'
  },
  mutations: {
    changeNavs (state,activeIndex) {
      state.activeIndex = activeIndex
    },
    changeNavsM (state,activeIndexM) {
      state.activeIndexM = activeIndexM
    },
  },
})

export default store // 导出store



// WEBPACK FOOTER //
// ./src/store/index.js